export enum UserAttributes {
    IS_NEW_USER = 'isNewUser',
    TRANSACTION_CLASSIFICATION_WALKME_STARTUP_STEP = 'transactionClassificationStartupStep',
    NEVER_SHOW_CREATE_RULE_PROMPT = 'neverShowCreateRulePrompt',
    IS_NATIVE_APP_USER = 'isNativeAppUser'
}
